import { render, staticRenderFns } from "./AcortadorCrear.vue?vue&type=template&id=fd344e7a&scoped=true"
import script from "./AcortadorCrear.vue?vue&type=script&lang=js"
export * from "./AcortadorCrear.vue?vue&type=script&lang=js"
import style0 from "./AcortadorCrear.vue?vue&type=style&index=0&id=fd344e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd344e7a",
  null
  
)

export default component.exports